<template>
	<div @click="getDetail"
		 class="pointer accent_color text-dense"
	>
		{{ companyName }}
	</div>
</template>

<script>

export default {
	computed: {
		companyName() {
			return this.params.data[this.params.colDef.nameType];
		},
		companyId() {
			return this.params.data[this.params.colDef.idType];
		}
	},
    methods: {
        getDetail() {
            if (this.companyId) {
                this.$store.dispatch("setActionNoticModal", {
                    show: true,
                    data: {
                        type: "CompanyDetailsModal",
						title: this.companyName,
						width: 800,
                        data: { id: this.companyId }
                    }
                });
            }
        }
    }
};
</script>
